import axios from 'axios';
import { Action } from 'types/api/Action';

export function getActions() {
  return axios.get<Action[]>('/api/v2/actions');
}
